import { useMemo } from 'react'
import { useI18n } from 'builder/hooks/useI18n'
import Icon24 from 'builder/components/Icon'
import { Caption, ScoreBar } from '../../styles'
import { LinkButton } from '../LinkButton/LinkButton'
import {
  Container,
  Content,
  ScoreBadge,
  ScoreBadgeContainer,
  ScoreDetailsContainer,
  Title,
} from './styles'

type Props = {
  title: string
  score?: number
  onChangeLink?: () => void
}

export const JobPostingDetails = (props: Props) => {
  const { i18n } = useI18n()
  const { score = 0, title, onChangeLink } = props

  const scoreBadgeLabel = useMemo(() => {
    if (score < 30) {
      return i18n.t('builder.resume_optimizer.job_posting.poor_match.score_title')
    } else if (score > 70) {
      return i18n.t('builder.resume_optimizer.job_posting.good_match.score_title')
    } else {
      return i18n.t('builder.resume_optimizer.job_posting.normal_match.score_title')
    }
  }, [score, i18n])

  return (
    <Container>
      <Content>
        <ScoreDetailsContainer>
          <Title>{title}</Title>
          {!!score && (
            <ScoreBadgeContainer>
              <ScoreBadge $score={score}>{score}%</ScoreBadge>
              <Caption>{scoreBadgeLabel}</Caption>
            </ScoreBadgeContainer>
          )}
        </ScoreDetailsContainer>
        {onChangeLink && (
          <LinkButton onClick={onChangeLink} icon={<Icon24.Revert />}>
            {i18n.t('builder.resume_optimizer.job_posting.try_again')}
          </LinkButton>
        )}
      </Content>
      <ScoreBar $score={score} />
    </Container>
  )
}
